var tradeMapsInitialState = {
    "instrument": "future",
    "p": [1, -1, 1, 1],
    "unitMove": [50, 50, 50, 50],
    "sampleContract": ["C2021U", "C2021Z", "C2021H", "C2022K"],
    selected: [],
    "mult": [1, 1, 1, 1],
    "legs": 1,
    "y1": 15,
      user: "A4A-user0",
    password: "M1-K8xQgmR",
    program: "TradeMaps",
    constrainContractAligner: true,
    chartParameters: {
        "amchartsChartType": "candlestick",
        chartsPerRow: 2,
        rowsPerPage: 2,
        chartsPerPage: 4,
        balloons: true,
        parameterToMap: "percentUp",
        initialZoom: false
    },
    search: {
        sortParameter: "rrr",
        legs: 2,
        position: "either",
        direction: "desc",
        source: "singleCommodity",
        minDays: 2,
        maxDays: 100,
        userConditions: [
            {
                parameter: "percentProfitable",
                comparator: ">",
                value: 70
            }
        ],
    },
    "generator": "PercentProfitableMapGenerator",
    "language": "en",
    "addBollinger": false,
    "addCOTPanel": false,
    "addRSIPanel": false,
    "addMACDPanel": false,
    "addATRPanel": false,
    "addVolumePanel": false,
    "addCCIPanel": false,
    "showTradingPeriod": true,
    "overwriteShow": false,
    "rsiPeriod": 7,
    "cciPeriod": 20,
    "volumeProfileColumns": 24,
    "cciSource": "closes",
    "chartScrollbarEnabled": false,
    "showBullets": true,
    "showSeasonals": true,
    "intracommodity": true,
    "stockGraphType": "line",
    "seasonals": [5, 15],
    balloons: false,
    truncate: 2
};

export {tradeMapsInitialState};